import React from "react";
import { Modal } from "react-bootstrap";
import { Icon } from "../../../components";
import styles from "./portal_modal.module.css";

interface PortalModalProps {
  title: string;
  body: JSX.Element;
  footer: JSX.Element;
  show: boolean;
  onHide: () => void;
  onClickBackButton?: () => void;
}

export function PortalModal({
  title,
  body,
  footer,
  show,
  onHide,
  onClickBackButton,
}: PortalModalProps) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName={styles.dialog}
      centered
      fullscreen="md-down"
      scrollable
    >
      <Modal.Header>
        <button
          className={`${styles.navBtn} ${
            !onClickBackButton && styles.hideBackBtn
          }`}
          onClick={onClickBackButton}
        >
          <Icon name="chevron-left" color="#B4B3BC" />
        </button>
        <div className={styles.title}>{title}</div>
        <button className={styles.navBtn} onClick={onHide}>
          <Icon name="x" color="#B4B3BC" />
        </button>
      </Modal.Header>
      <Modal.Body className={styles.dialogBody}>{body}</Modal.Body>
      <Modal.Footer className={styles.footer}>{footer}</Modal.Footer>
    </Modal>
  );
}
